import useCartController from 'hooks/use-cart-controller';
import useFeatureFlagsController from 'hooks/use-feature-flags-controller';
import useUserController from 'hooks/use-user-controller';
import useUIController from 'hooks/use-ui-controller';
import useSearchPreferencesController from 'hooks/use-search-preferences-controller';
import usePurchaseLimitsFlagsController from 'hooks/use-purchase-limits-flags-controller';
import useMinimumAgeOverridesFlagController from 'hooks/use-minimum-age-overrides-flag-controller';
import useCheckoutWidgetOnKioskFlagController from 'hooks/use-checkout-widget-on-kiosk-flag-controller';
import useSessionContextCookieController from 'hooks/use-session-context-cookie-controller';
import { usePhoneVerificationNudgeController } from 'src/hooks/use-phone-verification-nudge-controller';
import { usePhoneVerificationNudgeIntentAnalyticsFlag } from 'src/hooks/use-phone-verification-nudge-intent-analytics-flag';

export default function GlobalControllers() {
  useCartController();
  useFeatureFlagsController();
  useUserController();
  useUIController();
  useSearchPreferencesController();
  usePurchaseLimitsFlagsController();
  useMinimumAgeOverridesFlagController();
  useCheckoutWidgetOnKioskFlagController();
  useSessionContextCookieController();
  // Must run BEFORE usePhoneVerificationNudgeController: that controller's effect can
  // synchronously consume+track an already-present marker on the very first render (already
  // logged in on mount), and trackIntentMarkerConsumed() reads this hook's module-level flag
  // mirror. Hook effects within one component flush in declaration order, so mounting this
  // second would leave the mirror at its default `false` for that first render and silently
  // drop the event. See nudge-intent-marker-analytics.ts.
  usePhoneVerificationNudgeIntentAnalyticsFlag();
  usePhoneVerificationNudgeController();
  return null;
}
